// extracted by mini-css-extract-plugin
export default {"fieldTitle":"ChangedField_fieldTitle__jSIUr","changedValues":"ChangedField_changedValues__-TcZB","previous":"ChangedField_previous__xixh1"};